import React, { useState } from "react";
import {
  Button,
  AboutBtnLink,
  AboutContainer,
  AboutRow,
  AboutWrapper,
  BtnWrap,
  Column1,
  Column2,
  Heading,
  Img,
  ImgWrap,
  Subtitle,
  TextWrapper,
  TopLine,
  LikesWrapper,
} from "./AboutStyle";

const About = ({
  lightBg,
  id,
  imgStart,
  topLine,
  lightText,
  darkText,
  headline,
  description,
  buttonLabel,
  img,
  alt,
  dark,
  dark2,
  primary,
  href,
}) => {
  return (
    <AboutContainer lightBg={lightBg} id={id}>
      <AboutWrapper>
        <AboutRow imgStart={imgStart}>
          <Column1>
            <TextWrapper data-aos="fade-right" data-aos-mirror="true">
              <TopLine>{topLine}</TopLine>
              <Heading lightText={lightText}>{headline}</Heading>
              <Subtitle darkText={darkText}>{description}</Subtitle>
            </TextWrapper>
          </Column1>
          <Column2>
            <ImgWrap data-aos="fade-up" data-aos-mirror="true">
              <Img src={img} alt={alt} />
            </ImgWrap>
          </Column2>
        </AboutRow>
      </AboutWrapper>
    </AboutContainer>
  );
};

export default About;
